import { render, staticRenderFns } from "./feedbackHistory.vue?vue&type=template&id=5e4c9081&scoped=true&"
import script from "./feedbackHistory.vue?vue&type=script&lang=js&"
export * from "./feedbackHistory.vue?vue&type=script&lang=js&"
import style0 from "./feedbackHistory.vue?vue&type=style&index=0&id=5e4c9081&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c9081",
  null
  
)

export default component.exports